import { render, staticRenderFns } from "./SearchResult.vue?vue&type=template&id=4be22a2b&scoped=true"
import script from "./SearchResult.ts?vue&type=script&lang=ts&external"
export * from "./SearchResult.ts?vue&type=script&lang=ts&external"
import style0 from "./SearchResult.vue?vue&type=style&index=0&id=4be22a2b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be22a2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4be22a2b')) {
      api.createRecord('4be22a2b', component.options)
    } else {
      api.reload('4be22a2b', component.options)
    }
    module.hot.accept("./SearchResult.vue?vue&type=template&id=4be22a2b&scoped=true", function () {
      api.rerender('4be22a2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Searcher/pages/SearchResult/SearchResult.vue"
export default component.exports